export default __webpack_public_path__ + "static/client-2-7bf2490c454fef91af7c1453597a1805.webp";